import React, { useEffect, useMemo, useState } from "react";
import SidebarWrapper from "../../../../../../common-deprecated/components/SidebarWrapper";
import FilterList from "./FilterList";
import * as Styles from "./styles/FilterSidebarStyles";
import { type ModelFilterDispatchType, useModelFilterSelector } from "../../../redux/store";
import { showMoreFilters as showMoreFilterAction } from "../../../redux/actions/ModelFiltersActions";
import FilterPopupHeader from "../active-filters/top-bar/FilterPopupHeader";
import ActiveFilterSliderContainer from "../active-filters/slider/ActiveFilterSliderContainer";
import { useBreakpoint } from "../../../../../../common-deprecated/themes/common";
import { getMobileReachoutModalSize } from "../../../../../../common-deprecated/utils";
import useFilterSidebar from "../../../../../../shared-logic/features/filters/hooks/useFilterSidebar";
import { useDispatch } from "../../../../../../shared-logic/redux/store";
import { CONTROL_ID_FILTERS } from "../../../utils/constants/constants";

const FilterSidebar = (): JSX.Element => {
    const dispatch = useDispatch<ModelFilterDispatchType>();
    const hasMobileSidebar = useBreakpoint("down", "lg");
    const showMoreFilters = useModelFilterSelector((state) => state.modelFilters.showMoreFilters);
    const [componentInitialized, setComponentInitialized] = useState(false);
    const [mobileReachoutHeight, setMobileReachoutHeight] = useState(0);

    const showMoreFiltersDispatchFunction = () => dispatch(showMoreFilterAction(true));

    const { absoluteSidebar, setAbsoluteSidebar, enableSidebarTransition } = useFilterSidebar(
        showMoreFilters,
        true,
        componentInitialized,
        showMoreFiltersDispatchFunction,
    );

    useEffect(() => {
        // Set component initialized on mount
        setComponentInitialized(true);

        // check if the injected reachout component is available
        if (getMobileReachoutModalSize()) {
            setMobileReachoutHeight(getMobileReachoutModalSize());
        }
    }, []);

    const sidebarChildren = useMemo(
        () => (
            <>
                {hasMobileSidebar && <ActiveFilterSliderContainer />}
                <FilterList />
            </>
        ),
        [hasMobileSidebar],
    );

    return (
        <>
            {showMoreFilters && (
                <Styles.MobileHeader>
                    <FilterPopupHeader onClose={() => dispatch(showMoreFilterAction(false))} />
                </Styles.MobileHeader>
            )}
            <Styles.Wrapper
                show={showMoreFilters}
                onTransitionEnd={(event) => {
                    // Only set the sidebar to relative if the filters are shown.
                    // If they are not shown they should be absolute as that keeps the sidebar out of view.
                    if (event.propertyName === "width" && showMoreFilters) setAbsoluteSidebar(false);
                }}
                disableTransition={!enableSidebarTransition}
                reachOutMobile={mobileReachoutHeight}
                id={CONTROL_ID_FILTERS}
            >
                <Styles.SidebarContainer absolute={absoluteSidebar}>
                    {absoluteSidebar ? (
                        <div>{sidebarChildren}</div>
                    ) : (
                        <SidebarWrapper>{sidebarChildren}</SidebarWrapper>
                    )}
                </Styles.SidebarContainer>
            </Styles.Wrapper>
        </>
    );
};

export default FilterSidebar;
